/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlStartImpersonationRequest
 */
export interface ControlStartImpersonationRequest {
    /**
     * 
     * @type {string}
     * @memberof ControlStartImpersonationRequest
     */
    client_id: string;
}

/**
 * Check if a given object implements the ControlStartImpersonationRequest interface.
 */
export function instanceOfControlStartImpersonationRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "client_id" in value;

    return isInstance;
}

export function ControlStartImpersonationRequestFromJSON(json: any): ControlStartImpersonationRequest {
    return ControlStartImpersonationRequestFromJSONTyped(json, false);
}

export function ControlStartImpersonationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlStartImpersonationRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'client_id': json['client_id'],
    };
}

export function ControlStartImpersonationRequestToJSON(value?: ControlStartImpersonationRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'client_id': value.client_id,
    };
}

